import ValidationList from "./ValidationList";
export default ValidationList;
